// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5087) return "static/chunks/5087-f2bb55fba8b217fa.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"922":"d4ce1adac3d8be30","5287":"4a53b374b126a1a2","9418":"659ae3c40bb47741"}[chunkId] + ".js";
};